import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=7ccf5ab0&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=7ccf5ab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccf5ab0",
  null
  
)

export default component.exports